<template lang="pug">
  nav.navbar.is-transparent
    .navbar-brand
      router-link.navbar-item(:to="{name: 'Home'}")
        img(src="/static/logo-frequency-list.png" alt="Frequency List: Google Docs for english teachers" width="28" height="28")
      .navbar-burger.burger(
        data-target="navbarExampleTransparentExample"
        @click="showNavBar =  !showNavBar"
        :class="{'is-active': showNavBar}")
        span
        span
        span
    #navbarExampleTransparentExample.navbar-menu.has-text-left-mobile(:class="{'is-active': showNavBar}")
      .navbar-start
        button.navbar-item(
          @click.prevent="showNavBar = false;openSignUpModal"
          )
          | Sign up
        <!--router-link.navbar-item(:to="{name: 'ListPage'}" @click.native="showNavBar = false")-->
          <!--| List-->

      .navbar-end
        .navbar-item
          .field.is-grouped
            p.control
              search
            p.control
              router-link.button(:to="{name: 'MyAccount'}")
                b-icon(icon="account-circle")
                span Profile
            p.control
              button#btn_sign_out.button(@click="logout")
                b-icon(icon="exit-to-app")
                span Sign out
                <!--span Download-->

</template>

<script>
  import SearchEverywhere from '@/components/SearchEverywhere'
  import {mapGetters} from 'vuex'

  export default {
    name: 'BasicMenu',
    components: {
      search: SearchEverywhere
    },
    data () {
      return {
        showNavBar: false
      }
    },
    computed: mapGetters(['lastLessons', 'user']),
    mounted () {
    },
    methods: {

      logout() {
        this.$auth.logout({
          redirect: {name: 'ListPage'}
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BasicMenu.vue